export default function NotFound () {
    return (
        <h1>The page you're looking for is not available</h1>
    )
}
